import './inner.css';
import 'react-dropdown/style.css';

const Inner = ({ content, isContentDynamic }) => {

  return (
    <div className="innerWrapper">
      <div className={`inner ${isContentDynamic ? "dynamicContent" : ""}`} >
        {content}
      </div>
    </div>
  );
};

export default Inner;
